import React from 'react';
import { TablePagination as MuiTablePagination } from '@mui/material';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { RootState } from 'store/types';
import { setPage, setRowsPerPage } from 'store/table';

import { TablePaginationTypes } from 'components/Table/constants';
import { tt } from '@i18n/tt';

const TablePagination: React.FC = () => {
  const dispatch = useAppDispatch();

  const { page, rowsPerPage, totalCount } = useAppSelector((state: RootState) => state.table);

  return (
    <MuiTablePagination
      count={totalCount}
      page={page}
      rowsPerPageOptions={TablePaginationTypes}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={e => {
        if (page * +e.target.value > totalCount) {
          dispatch(setPage(Math.floor(totalCount / +e.target.value)));
        }
        dispatch(setRowsPerPage(+e.target.value));
      }}
      onPageChange={(e, b) => {
        dispatch(setPage(b));
      }}
      labelRowsPerPage={tt('table.RowsPerPage')}
    />
  );
};

export default TablePagination;
